export const SetSettings = (settings) => {
	return async dispatch => {
		await dispatch({
			type: 'SET_SETTINGS',
			payload: settings
		});
	}
}